import { is } from '@common/is/is'

/**
 * Window elkérése.
 * Ha van topmost window, akkor azt adja vissza, különben a window-t.
 * Topmost window abban az esetben van, ha iframe beágyaázás történik.
 */
export default function getWindow (): Window {
  const w = is.null(window.top)
    ? window
    : window.top

  return w
}
